import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  NumberInput,
  NumberInputField,
  FormControl,
  Flex,
  Box,
  ModalFooter,
  FormLabel,
  Input
} from '@chakra-ui/react'
import { FC } from 'react'
import { BiSliderAlt } from 'react-icons/bi'
import { FiEdit2 } from 'react-icons/fi'
import { IoIosAddCircle } from 'react-icons/io'

import useParametrizationSimilarProduct from '@hook/parametrization/use-similar-product'

import Filter from '@component/Shared/Filter'
import SelectAsyncPaginateFromApiPost from '@component/Shared/FilterPaginationApiPost'

const ParametrizationSimilarProductCreate: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const {
    filterEdit,
    loadingEdit,
    paramsEdit,
    selected,
    handleUpdateEditParams,
    createData,
    updateProductSimilar
  } = useParametrizationSimilarProduct()

  return (
    <>
      {selected !== 0 ? (
        <Button
          fontSize={14}
          size="sm"
          marginLeft={2}
          leftIcon={<FiEdit2 />}
          colorScheme="green"
          variant="outline"
          onClick={onOpen}
        >
          Editar
        </Button>
      ) : (
        <Button
          fontSize={14}
          size="sm"
          leftIcon={<IoIosAddCircle />}
          colorScheme="blue"
          variant="outline"
          onClick={onOpen}
        >
          Adicionar
        </Button>
      )}
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            bg="white"
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {selected !== 0
                  ? 'Editar Produto Similar'
                  : 'Criar Produto Similar'}
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody bg="white" pt={0} py={4}>
            <FormControl isRequired>
              <Filter
                label="Empresa"
                options={filterEdit.centers}
                value={paramsEdit.empresa}
                isDisabled={selected !== 0}
                onChange={value =>
                  handleUpdateEditParams({ name: 'empresa', value: value })
                }
                isLoading={loadingEdit}
              />
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <SelectAsyncPaginateFromApiPost
                label="Produto Novo"
                apiUrl="/v1/Produto"
                value={paramsEdit.produtoNovo}
                isDisabled={selected !== 0}
                onChange={value =>
                  handleUpdateEditParams({ name: 'produtoNovo', value: value })
                }
              />
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <SelectAsyncPaginateFromApiPost
                label="Produto Similar"
                apiUrl="/v1/Produto"
                value={paramsEdit.produtoSimilar}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'produtoSimilar',
                    value: value
                  })
                }
              />
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>(*) Demanda Absorvida</FormLabel>
              <NumberInput
                borderBottomColor="black"
                value={paramsEdit.demanda}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'demanda',
                    value: value
                  })
                }
              >
                <NumberInputField />
              </NumberInput>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>Data Inicio</FormLabel>
              <Input
                borderBottomColor="black"
                type="date"
                value={paramsEdit.dataInicio}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'dataInicio',
                    value: value.target.value
                  })
                }
              ></Input>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>Data Fim</FormLabel>
              <Input
                borderBottomColor="black"
                type="date"
                value={paramsEdit.dataFim}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'dataFim',
                    value: value.target.value
                  })
                }
              ></Input>
            </FormControl>
            <br></br>
          </ModalBody>
          <ModalFooter
            bg="white"
            borderBottomLeftRadius={5}
            borderBottomRightRadius={5}
          >
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                if (selected !== 0) {
                  updateProductSimilar()
                  onClose()
                } else {
                  createData()
                  onClose()
                }
              }}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ParametrizationSimilarProductCreate
